import { render } from "./OtpSetupQr.vue?vue&type=template&id=76f71461"
import script from "./OtpSetupQr.vue?vue&type=script&lang=js"
export * from "./OtpSetupQr.vue?vue&type=script&lang=js"

import "./OtpSetupQr.vue?vue&type=style&index=0&id=76f71461&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__